import React, { useEffect } from 'react';
import { ModelPropertiesParser } from '../commons/modelPropertiesParser';
import { useEfr } from "../../utils/useEfr";


const FaceRecognition = (props) => {
  const {
    layoutItem: {
      itemProperties: { efrConfig },
    },
    workflowData,
    change
  } = props;
  const tokenField = efrConfig && efrConfig.tokenField;
  const configurationTokenField = efrConfig && efrConfig.configurationTokenField;
  const temporaryTokenField = efrConfig && efrConfig.temporaryTokenField;
  const codeField = efrConfig && efrConfig.codeField;
  const expiryField = efrConfig && efrConfig.expiryField;
  const fieldToUpdate = efrConfig && efrConfig.fieldToUpdate;
  const sdkFaceData = efrConfig && efrConfig.sdkFaceData;
  const datahash = efrConfig && efrConfig.datahash;
  const thumbnail = efrConfig && efrConfig.thumbnail;
  const tag = efrConfig && efrConfig.tag;


  if (!tokenField && !configurationTokenField && !temporaryTokenField && !codeField && !expiryField) return <div>Please configure EFR</div>
  const token = ModelPropertiesParser(tokenField, workflowData);
  const configurationToken = ModelPropertiesParser(configurationTokenField, workflowData);
  const temporaryToken = ModelPropertiesParser(temporaryTokenField, workflowData);
  const code = ModelPropertiesParser(codeField, workflowData);
  const expiry = ModelPropertiesParser(expiryField, workflowData);
  const secretKey = {
    "code": code,
    "value": temporaryToken,
    "expiry": expiry
  }

  console.log(secretKey);
  const { livenessSdk } = props
  const { loading, data } = useEfr(token, configurationToken, secretKey, livenessSdk, (faceData) => {
    console.log(`face data`, faceData)

    if (faceData && faceData.data && faceData.datahash && faceData.thumbnail && faceData.tag) {
      change(sdkFaceData, faceData.data);
      change(datahash, faceData.datahash);
      change(thumbnail, faceData.thumbnail);
      change(tag, faceData.tag);
    }

  });
  // if(fieldToUpdate && data.status != undefined && data.status == true) {

  // } else if(data.status == false) {
  //   change(fieldToUpdate, data.errors[0].message);
  // }
  return (
    <div>
      <div className='loader' id='loader'></div>
      <>
        {loading ? <h1>Processing</h1> : <h1>EFR SDK</h1>}
        {data.status != undefined && data.status == true ? (
          <>
            <h1>Success</h1>
            <img src={data.thumbnail} />
          </>
        ) : data.status == false ? (
          <h1>{data.errors[0].message}</h1>
        ) : (
          ""
        )}
      </>
    </div>
  );
};

export default FaceRecognition;
